import { render, staticRenderFns } from "./ModalDeleteUser.vue?vue&type=template&id=d72c9622&scoped=true&lang=html&"
import script from "./ModalDeleteUser.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72c9622",
  null
  
)

export default component.exports